import {DceAjaxAction} from "dce-ajax";

interface ReplaceElementData {
    elements: {
        element: string,
        selector: string
    }[];
}

function createDomElementFromString(value: string): Element{
    if(null == value || value == ''){
        return document.createElement('div');
    }
    let elem = document.createElement('div');
    elem.innerHTML = value.trim();
    return elem.firstElementChild;
}

export default class DceAjaxReplaceElementAction implements DceAjaxAction {

    execute(data: any): void {
        let arr = data as ReplaceElementData;

        arr.elements.forEach(d => {
            document.querySelectorAll(d.selector).forEach(elem => {
                let element = createDomElementFromString(d.element);
                elem.replaceWith(element);
            });
        });

    }

    getPriority(): number {
        return 0;
    }

}
